import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { GET_COUNTRIES, GET_CITIES_BY_COUNTRY } from "./actionTypes"
import {
  getCountriesSuccess,
  getCountriesFail,
  getCitiesByCountrySuccess,
  getCitiesByCountryFail
} from "./actions";

//Include Both Helper File with needed methods
import { 
  getCountries,
  getCitiesByCountry
} from "../../helpers/backend_helper";

function* fetchCountries() {
  try {
    const response = yield call(getCountries);
    yield put(getCountriesSuccess(response));
  } catch (error) {
    yield put(getCountriesFail(error));
  }
}

function* fetchCitiesByCountry({payload:id}) {
  try {
    const response = yield call(getCitiesByCountry,id)
    yield put(getCitiesByCountrySuccess(response))
  } catch (error) {
    yield put(getCitiesByCountryFail(error))
  }
}


function* addressSaga() {
  yield takeEvery(GET_COUNTRIES, fetchCountries);
  yield takeEvery(GET_CITIES_BY_COUNTRY, fetchCitiesByCountry);
}

export default addressSaga;
